import React from 'react'
import classNames from 'classnames'

const CardBody = props => {
  return (
    <div className={classNames('card_body', props.className)}>
      {props.children}
    </div>
  )
}
export default CardBody
